import React, { Component } from "react";
import { check, included_releases, show_release_note } from "../../resources/string/strings"
import { ReactComponent as IconIncludedReleases } from "../../resources/image/ic_included_releases.svg";
import { Link } from "react-router-dom";

class Adapter extends Component {
  state = {
  };

  render() {
    const { id, includedReleases } = this.props;

    return (

      <div style={{ textAlign: "right" }} >

        <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right" , marginBottom: 10}}>
          <IconIncludedReleases
            className="p-0"
            width="25"
            height="25"
          />
          <span style={{ fontSize: 13, color: "dimgrey", marginRight: 6 }}>{included_releases}</span>

        </div>

        {includedReleases.map((item) => (
          <div 
          key={item.title}
          style={{ fontSize: 13, color: "black", marginBottom: 10 }}>

            <span dir="ltr">{item.versionName}</span>
      
            <span style={{marginRight: 10}}>
            <Link target="_blank" to={"/releases/detail?i=" + item.id} style={{ height: 16, width: 90, fontSize: 13, textDecoration: "none" }}>{check}</Link>


            </span>
            
            </div>
        ))}

        <Link target="_blank" to={"/releases/detail/releaseNote?i=" + id} className="btn-info btn" style={{color: "white", fontSize: 13, paddingTop: 4, paddingBottom: 4}}>{show_release_note}</Link>
      </div>
    );
  }
}

export default Adapter;
